import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ReceiptHeaderRead } from '../../entities/receipt-header.dto';

@Injectable()
export class ReceiptHeaderStore extends AbstractEntityStore<ReceiptHeaderRead> {
    constructor() {
        super(PFWmsEntities.ReceiptHeader);
    }
}
